<template>
  <div id="range-year-slider" class="range-year-slider hide-for-print" v-bind:class="{ 'isRangeSameYear' : (isRangeSameYear() === true), 'isRange' : (isRangeSlider() === true) }">
    <vue-slider
        :lazy="true"
        :max="maxYear"
        :min="minYear"
        :piecewise="true"
        :piecewise-label="true"
        :piecewiseStyle='{
          "backgroundColor": "#2F3E5E",
          "width": "4px",
          "height": "4px"
        }'
        :tooltipStyle='
        [
          {
            "backgroundColor": "#F1F3F7",
            "borderColor": "#F1F3F7",
            "boxShadow": "0 0 10px 0 RGBA(0,0,0,0.1)",
            "color": "#2F3E5E",
            "font-size": "14px",
            "border-radius": "3px"
          },
          {
            "backgroundColor": "#F1F3F7",
            "borderColor": "#F1F3F7",
            "color": "#2F3E5E",
            "font-size": "14px",
            "border-radius": "3px"
          }
        ]'
        v-model="current"
        class="range-year-slider__slider"
        ref="slider"
        tooltip="hover"
        tooltip-dir="top"
      ></vue-slider>
  </div><!-- /.single-year-slider -->
</template>

<script>
import vueSlider from 'vue-slider-component'
import {EventBus} from '@/event-bus.js'

export default {
  name: 'range-year-slider',
  components: { vueSlider },
  data () {
    return {
      current: this.startSelection,
      minYear: this.years[0],
      maxYear: this.years[1]
    }
  },
  mounted () {
    this.refresh()
    EventBus.$on('slider.refresh', this.refresh)
  },
  destroyed () {
    EventBus.$off('slider.refresh', this.refresh)
  },
  watch: {
    current () {
      if (this.isRangeSlider()) {
        this.$store.state.rangeYearSliderCurrent = this.current
      } else {
        this.$store.state.yearSliderCurrent = this.current
      }
    }
  },
  props: {
    years: {
      type: Array,
      // TODO: make these rely on $store.state.defaultYears
      default: () => [1975, 2021]
    },
    startSelection: {
      // TODO: make these rely on $store.state.defaultYears
      default: () => [1975, 2021]
    }
  },
  methods: {
    refresh () {
      this.$refs.slider.refresh()
    },
    isRangeSlider () {
      return (this.startSelection instanceof Array)
    },
    isRangeSameYear () {
      return this.isRangeSlider() && this.current[0] === this.current[1]
    }
  }
}
</script>

<style lang="scss">
@import '~@/components/sass/shared/colors';

.worldmap .rangeSlider{
  flex: 1 1 auto; -ms-flex: 1 1 auto;
  margin: 20px 60px !important;
}

.single-country .rangeSlider{
    margin: 40px 0 20px;
}

.range-year-slider{
  height: 60px !important;
}

.range-year-slider__slider{

  .vue-slider{
    background: none !important;
  }

  .vue-slider-piecewise-dot{
    height: 5px !important;
    width: 5px !important;
  }

  .vue-slider-piecewise li:first-child .vue-slider-piecewise-dot,
  .vue-slider-piecewise li:last-child .vue-slider-piecewise-dot{
    visibility: visible !important;
  }

  // .vue-slider-tooltip-bottom{
  //   bottom: 20px !important;
  // }

  &.vue-slider-horizontal .vue-slider-process{
    background: transparent !important;
    height: 20px !important;
    top: -7px !important;
  }

  &.isRange.vue-slider-horizontal .vue-slider-process{
    background: #EEE !important;
  }

  .vue-slider-piecewise li{
    .vue-slider-piecewise-label{
      font-size: 14px !important;
      // pointer-events: none;
      display: none !important;
      // top: -14px !important;
      // z-index: 4;
    }

    &:nth-child(5n+1) {

      .vue-slider-piecewise-dot{
        height: 6px !important;
        width: 6px !important;
      }

      .vue-slider-piecewise-label{
        cursor: pointer;
        display: inline-block !important;
        padding-top: 15px !important;
        color: $gray-darkest !important;
      }
    }
  }

  .vue-slider-dot{
    background: $gray-light !important;
    box-shadow: none !important;
    border-radius: 20px !important;
    left: -7px !important;
    padding: 0 !important;
    position: relative !important;
    top: -30px !important;
    transition: padding 100ms ease !important;
    height: 30px !important;
    width: 30px !important;

    &:first-child { top: -12px !important; }

    &:after{
      content: "\25C4\25BA";
      display: block;
      font-size: 10px;
      left: 0;
      letter-spacing: 1px;
      line-height: 29px;
      position: absolute;
      top: 0;
      text-align: center;
      text-indent: 2px;
      width: 100%;
    }
  }
}

.isRangeSameYear .range-year-slider__slider .vue-slider-dot:after,
.isRangeSameYear .range-year-slider__slider .vue-slider-dot:first-child:after {
  content: "\25C4\25BA";
  font-size: 6px;
  letter-spacing: 2px;
  text-indent: 2px;
}

.isRange .vue-slider-dot {
  &:after{
    content: "\25BA";
    font-size: 8px;
  }
  &:first-child:after{ content: "\25C4"; }
}

.vue-slider-process{
  border-radius: 0 !important;
}

.isRange .vue-slider-horizontal .vue-slider-process{
  background: $gray-lightest !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/sliders/RangeYearSlider.vue